export default class Loader {
    constructor(parent) {
        this.el = parent.el.querySelector('.sp-loader');
    }

    show() {
        this.el.classList.remove('hide');
    }

    hide() {
        this.el.classList.add('hide');
    }
}
